<template>
  <div class="LKMunMehCardForm">
    <div class="LKMunMehCardForm__left">
      <LKMunMehCardFormLeft
        :data="data"
        :disabled="isDisabled"
      />
    </div>

    <div class="LKMunMehCardForm__right">
      <LKMunMehCardFormRight
        :data="data"
        :disabled="isDisabled"
      />
    </div>
  </div>
</template>

<script>
import LKMunMehCardFormLeft from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCardFormLeft.vue'
import LKMunMehCardFormRight from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCardFormRight.vue'
import { isAfterToday, isBeforeToday } from '@/helpers/dateFormatter'
import { lkMapper } from '@/store/modules/lk'


export default {
  name: 'LKMunMehCardForm',
  components: { LKMunMehCardFormLeft, LKMunMehCardFormRight },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...lkMapper.mapGetters(['profile']),
    isDisabled() {
      const { data, profile } = this
      const { start_at, end_at } = data

      const isStartDatesBeforeToday = (!start_at || isAfterToday(start_at, profile.msk_diff))
      const isEndDatesAfterToday = (!end_at || isBeforeToday(end_at, profile.msk_diff))
      return isStartDatesBeforeToday || isEndDatesAfterToday
    },
  },
}
</script>

<style lang="scss">
.LKMunMehCardForm {
  position: relative;
  display: flex;
  padding: 18px 22px 25px 22px;
  background-color: $webflow-color-blue-shadow;

  &__left {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  &__right {
    padding-left: 24px;
    margin-left: 24px;
  }
}
</style>
